import type React from "react";
import {
  ResizableHandle as ShadcnResizableHandle,
  ResizablePanel as ShadcnResizablePanel,
  ResizablePanelGroup as ShadcnResizablePanelGroup,
} from "src/shadcn/components/resizable";

const ResizableHandle = (
  props: React.ComponentProps<typeof ShadcnResizableHandle>
) => <ShadcnResizableHandle {...props} />;

const ResizablePanel = (
  props: React.ComponentProps<typeof ShadcnResizablePanel>
) => <ShadcnResizablePanel {...props} />;

const ResizablePanelGroup = (
  props: React.ComponentProps<typeof ShadcnResizablePanelGroup>
) => <ShadcnResizablePanelGroup {...props} />;

export { ResizableHandle, ResizablePanel, ResizablePanelGroup };
